module.exports = __webpack_public_path__ + "img/pf.34d3495a.jpg";